import React from "react"
import { Space, Table, Tag, Tooltip, Typography } from "antd"
import { ProcessCascade } from "./process-cascade"
import { STAGES, STATUSES, formatDateTime, formatDuration, formatError } from "./labels"

function Cascade({ steps }) {
  if (steps.length === 0) return "—"

  return (
    <Space size={2} wrap>
      {steps.map((step, index) => (
        <React.Fragment key={step.id}>
          {index > 0 && <span>→</span>}
          <Tooltip title={`${step.stageLabel}: ${step.statusLabel}${step.error ? ` — ${formatError(step.error)}` : ""}`}>
            <Tag color={step.status === "success" ? "success" : step.status === "pending" ? "processing" : step.status === "next" ? "default" : "error"}>
              {STAGES[step.stage]?.short ?? step.stage}
            </Tag>
          </Tooltip>
        </React.Fragment>
      ))}
    </Space>
  )
}

export function AuthRequestsTable({ items, pagination, filters, isLoading, onChange, loadProcess }) {
  const columns = [
    {
      title: "Дата и время",
      dataIndex: "startedAt",
      key: "startedAt",
      sorter: true,
      sortOrder: filters.direction === "asc" ? "ascend" : "descend",
      sortDirections: ["descend", "ascend", "descend"],
      render: formatDateTime,
    },
    {
      title: "Пользователь",
      dataIndex: "phone",
      render: (phone, row) => (
        <>
          <Typography.Text copyable={{ text: phone }}>{phone}</Typography.Text>
          {row.processRequestsCount > 1 && (
            <Tooltip title="Запросов в этом процессе входа — раскройте строку">
              <Tag style={{ marginLeft: 8 }}>×{row.processRequestsCount}</Tag>
            </Tooltip>
          )}
        </>
      ),
    },
    {
      title: (
        <Tooltip title="Оператор связи МТС ID не передаёт; определение по номеру — отдельная задача">
          Оператор
        </Tooltip>
      ),
      render: () => <Typography.Text type="secondary">—</Typography.Text>,
    },
    {
      title: "Способ авторизации",
      dataIndex: "method",
      render: (method) => (method ? <Tag color={STAGES[method]?.color}>{STAGES[method]?.label ?? method}</Tag> : "—"),
    },
    {
      title: "Статус",
      dataIndex: "status",
      render: (status, row) => {
        const meta = STATUSES[status]
        const tag = <Tag color={meta?.color}>{meta?.label ?? status}</Tag>
        return row.error ? <Tooltip title={formatError(row.error)}>{tag}</Tooltip> : tag
      },
    },
    { title: "Каскад", dataIndex: "steps", render: (steps) => <Cascade steps={steps} /> },
    { title: "Ввод кода", dataIndex: "codeAttempts", align: "right", render: (value) => value || "—" },
    { title: "Длительность", dataIndex: "durationMs", align: "right", render: formatDuration },
  ]

  return (
    <Table
      size="small"
      rowKey="id"
      loading={isLoading}
      dataSource={items}
      columns={columns}
      onChange={onChange}
      scroll={{ x: 1100 }}
      pagination={{ ...pagination, showSizeChanger: true, pageSizeOptions: [20, 50, 100], showTotal: (total) => `Всего: ${total}` }}
      expandable={{
        expandedRowRender: (row) => <ProcessCascade processId={row.processId} loadProcess={loadProcess} />,
      }}
    />
  )
}
